<div
  *ngIf="isLoading"
  class="u-position-absolute"
  [ngStyle]="{ top: 0, left: 0, right: 0 }"
  [@fadeInEnter]
>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div
  [ngStyle]="{ width: '760px', maxWidth: '95vw', minHeight: '100vh' }"
  class="u-margin-center u-padding-40-0"
>
  <div
    *ngIf="viewMode === USER_ONBOARDING_ROUTE_PATHS.hubSegments"
    [@fadeInEnter]
  >
    <div
      class="u-borderBottom-grey100 u-paddingBottom-24 u-marginBottom-32 u-textAlign-center"
    >
      <app-avatar-tenant
        class="u-display-inlineBlock u-marginBottom-16"
        [item]="tenant"
        [size]="96"
      >
      </app-avatar-tenant>
      <h5
        i18n="@@userOnboardingView.hubPreferences.segments.title"
        class="u-textDecoration-bold"
      >
        Hi {{ user.first_name }}!
      </h5>
      <p
        i18n="@@userOnboardingView.hubPreferences.segments.description"
        class="color-grey-300 u-text-maxWidth u-margin-center u-marginBottom-16"
      >
        Tell us a bit more about yourself to help us personalize your
        experience.
      </p>
      <app-progress-steps
        fxLayout="row"
        fxLayoutGap="8px"
        fxLayoutAlign="center center"
        class="u-display-block"
        [currentStep]="0"
        [numberOfSteps]="numberOfSteps"
      >
      </app-progress-steps>
    </div>
    <form
      *ngIf="group?.roles"
      [ngStyle]="{ maxWidth: '360px' }"
      class="u-margin-center"
      [formGroup]="segmentsForm"
    >
      <div class="u-marginBottom-24">
        <div class="u-marginBottom-16">
          <p i18n="@@userOnboardingView.hubPreferences.segments.label">
            What best describes your role?
          </p>
          <nz-select
            (ngModelChange)="roleChanged($event)"
            class="u-width-100 u-marginBottom-8"
            formControlName="role"
            nzPlaceHolder="Select your answer"
            i18n-nzPlaceHolder="
              @@userOnboardingView.hubPreferences.segments.placeholder"
          >
            @for (role of group.roles; track role.name) {
              <nz-option
                [nz-tooltip]="role.name | translationLookup: ['@@groupRole']"
                [nzLabel]="role.name | translationLookup: ['@@groupRole']"
                [nzTooltipMouseEnterDelay]="0.5"
                [nzValue]="role.name"
              ></nz-option>
            }
          </nz-select>
          <mat-hint *ngIf="!!hints.role" [@fadeInEnter]>
            <span
              i18n="@@userOnboardingView.hubPreferences.segments.roleHint"
              class="color-teal-700"
              >{hints.role, select, other {{{ hints.role }}}
            }</span>
          </mat-hint>
        </div>
        @for (segment of group.custom_segments; track $index) {
          @if (
            segment?.nodes?.length &&
            (segment?.privacy_settings?.visible_in_onboarding ?? true)
          ) {
            <div class="u-marginBottom-16">
              <app-group-custom-segment-header
                [customSegment]="segment"
                [user]="user"
              ></app-group-custom-segment-header>
              <nz-select
                [formControl]="
                  $any(
                    segmentsForm.get('customSegments').get($index.toString())
                  )
                "
                [nzMenuItemSelectedIcon]="emptyTemplate"
                [nzMode]="
                  'multi' === segment.selection_type ? 'multiple' : 'default'
                "
                (ngModelChange)="
                  updateSegmentSelections(segment, $event, $index)
                "
                class="u-width-100 u-marginBottom-8 u-marginTop-8"
                nzPlaceHolder="Select your answer"
                nzShowSearch
                i18n-nzPlaceHolder="
                  @@userOnboardingView.hubPreferences.segments.placeholder"
              >
                <nz-option
                  *ngFor="let option of segment.nodes"
                  [nz-tooltip]="option.name"
                  [nzLabel]="
                    option.name
                      | translationLookup: ['@@groupCustomSegmentOption']
                  "
                  [nzTooltipMouseEnterDelay]="0.5"
                  [nzValue]="option.name"
                  nzCustomContent
                >
                  @if ('multi' === segment.selection_type) {
                    <ng-container
                      [ngTemplateOutlet]="multiselectCheck"
                      [ngTemplateOutletContext]="{
                        formValue: segmentsForm
                          .get('customSegments')
                          .get($index.toString()).value,
                        optionName: option.name,
                      }"
                    ></ng-container>
                  }
                  {{
                    option.name
                      | translationLookup: ['@@groupCustomSegmentOption']
                  }}
                </nz-option>
              </nz-select>
              @if (!!hints.customSegments[$index]) {
                <mat-hint [@fadeInEnter]>
                  <span
                    i18n="
                      @@userOnboardingView.hubPreferences.segments.customSegmentHint"
                    class="color-teal-700"
                    >{hints.customSegments[$index], select,
                      other {{{ hints.customSegments[$index] }}}

                  }</span>
                </mat-hint>
              }
            </div>
          }
        }
        @for (segment of group.hidden_custom_segments; track $index) {
          @if (
            segment?.nodes?.length &&
            (segment?.privacy_settings?.visible_in_onboarding ?? true)
          ) {
            <div class="u-marginBottom-16">
              <app-group-hidden-custom-segment-header
                [customSegment]="segment"
                [user]="user"
              ></app-group-hidden-custom-segment-header>
              <nz-select
                [formControl]="
                  $any(
                    segmentsForm
                      .get('hiddenCustomSegments')
                      .get($index.toString())
                  )
                "
                [nzMenuItemSelectedIcon]="emptyTemplate"
                [nzMode]="
                  'multi' === segment.selection_type ? 'multiple' : 'default'
                "
                (ngModelChange)="
                  updateHiddenSegmentSelections(segment, $event, $index)
                "
                class="u-width-100 u-marginBottom-8 u-marginTop-8"
                nzPlaceHolder="Select your answer"
                i18n-nzPlaceHolder="
                  @@userOnboardingView.hubPreferences.segments.placeholder"
                nzShowSearch
              >
                <nz-option
                  *ngFor="let option of segment.nodes"
                  [nz-tooltip]="
                    option.name
                      | translationLookup: ['@@groupCustomSegmentOption']
                  "
                  [nzLabel]="
                    option.name
                      | translationLookup: ['@@groupCustomSegmentOption']
                  "
                  [nzTooltipMouseEnterDelay]="0.5"
                  [nzValue]="option.name"
                  nzCustomContent
                >
                  @if ('multi' === segment.selection_type) {
                    <ng-container
                      [ngTemplateOutlet]="multiselectCheck"
                      [ngTemplateOutletContext]="{
                        formValue: segmentsForm
                          .get('hiddenCustomSegments')
                          .get($index.toString()).value,
                        optionName: option.name,
                      }"
                    ></ng-container>
                  }
                  {{
                    option.name
                      | translationLookup: ['@@groupCustomSegmentOption']
                  }}
                </nz-option>
              </nz-select>
              @if (!!hints.hiddenCustomSegments[$index]) {
                <mat-hint [@fadeInEnter]>
                  <span class="color-teal-700">{{
                    hints.hiddenCustomSegments[$index]
                  }}</span>
                </mat-hint>
              }
            </div>
          }
        }
      </div>
      <button
        i18n="@@global.continue"
        type="button"
        mat-raised-button
        color="primary"
        (click)="navigateToNextView.emit(group)"
        [disabled]="!isMembershipValid()"
      >
        Continue
      </button>
    </form>
  </div>
  <div
    *ngIf="viewMode === USER_ONBOARDING_ROUTE_PATHS.hubInterests"
    [@fadeInEnter]
  >
    <div
      class="u-borderBottom-grey100 u-paddingBottom-24 u-marginBottom-32 u-textAlign-center"
    >
      <app-avatar-tenant
        class="u-display-inlineBlock u-marginBottom-16"
        [item]="tenant"
        [size]="96"
      >
      </app-avatar-tenant>
      <h5 i18n="@@global.selectInterests" class="u-textDecoration-bold">
        Select your interests
      </h5>
      <p
        i18n="@@userOnboardingView.hubPreferences.interests.overview"
        class="color-grey-300 u-text-maxWidth u-margin-center u-marginBottom-16"
      >
        We'll help you find members who have the same interests as you.
      </p>
      <app-progress-steps
        fxLayout="row"
        fxLayoutGap="8px"
        fxLayoutAlign="center center"
        class="u-display-block"
        [currentStep]="2"
        [numberOfSteps]="numberOfSteps"
      >
      </app-progress-steps>
    </div>
    <div [ngStyle]="{ maxWidth: '500px' }" class="u-margin-center">
      <ng-container
        *ngIf="
          (group?.field_descriptions | appFind: 'name' : 'industries')
            ?.description as interestsDescription
        "
      >
        <p class="color-grey-300 u-marginBottom-16 u-whiteSpace-preLine">
          {{
            interestsDescription
              | translationLookup: ['@@groupIndustriesDescription']
          }}
        </p>
      </ng-container>
      <app-group-topics-picker
        class="u-display-block u-marginBottom-24"
        [items]="group.industries"
        [initialItems]="
          (user?.groups | appGroupMembership: group._id)?.industries
        "
        (itemsChanged)="interestsForm.patchValue($event)"
      >
      </app-group-topics-picker>
      <div class="u-margin-center u-textAlign-center">
        <button
          type="button"
          mat-raised-button
          color="primary"
          (click)="updateItems({ industries: interestsForm.value })"
          [disabled]="isLoading"
          i18n="@@global.continue"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="viewMode === USER_ONBOARDING_ROUTE_PATHS.hubGoals" [@fadeInEnter]>
    <div
      class="u-borderBottom-grey100 u-paddingBottom-24 u-marginBottom-32 u-textAlign-center"
    >
      <app-avatar-tenant
        class="u-display-inlineBlock u-marginBottom-16"
        [item]="tenant"
        [size]="96"
      >
      </app-avatar-tenant>
      <h5 i18n="@@global.selectGoals" class="u-textDecoration-bold">
        Select your goals
      </h5>
      <p
        i18n="@@userOnboardingView.hubPreferences.goals.overview"
        class="color-grey-300 u-text-maxWidth u-margin-center u-marginBottom-16"
      >
        We'll help you find members who can help you achieve your goals.
      </p>
      <app-progress-steps
        fxLayout="row"
        fxLayoutGap="8px"
        fxLayoutAlign="center center"
        class="u-display-block"
        [currentStep]="3"
        [numberOfSteps]="numberOfSteps"
      >
      </app-progress-steps>
    </div>
    <div [ngStyle]="{ maxWidth: '360px' }" class="u-margin-center">
      <ng-container
        *ngIf="
          (group?.field_descriptions | appFind: 'name' : 'offerings')
            ?.description as goalsDescription
        "
      >
        <p class="color-grey-300 u-marginBottom-16 u-whiteSpace-preLine">
          {{
            goalsDescription
              | translationLookup: ['@@groupOfferingsDescription']
          }}
        </p>
      </ng-container>
      <app-group-offerings-picker
        class="u-display-block u-marginBottom-24"
        [items]="group.offerings"
        [initialItems]="{
          offerings: (user?.groups | appGroupMembership: group._id)?.offerings,
          seeking: (user?.groups | appGroupMembership: group._id)?.seeking,
        }"
        (itemsChanged)="
          goalsForm.patchValue({
            offerings: $event.offerings,
            seeking: $event.seeking,
          })
        "
      >
      </app-group-offerings-picker>
      <button
        i18n="@@global.continue"
        type="button"
        mat-raised-button
        color="primary"
        (click)="
          updateItems({
            offerings: goalsForm.value.offerings,
            seeking: goalsForm.value.seeking,
          })
        "
        [disabled]="isLoading"
      >
        Continue
      </button>
    </div>
  </div>
  <div
    *ngIf="viewMode === USER_ONBOARDING_ROUTE_PATHS.hubInteractions"
    [@fadeInEnter]
  >
    <div
      class="u-borderBottom-grey100 u-paddingBottom-24 u-marginBottom-32 u-textAlign-center"
    >
      <app-avatar-tenant
        class="u-display-inlineBlock u-marginBottom-16"
        [item]="tenant"
        [size]="96"
      >
      </app-avatar-tenant>
      <h5
        i18n="@@userOnboardingView.hubPreferences.interactions.title"
        class="u-textDecoration-bold"
      >
        How would you like to participate?
      </h5>
      <p
        i18n="@@userOnboardingView.hubPreferences.interactions.overview"
        class="color-grey-300 u-text-maxWidth u-margin-center u-marginBottom-16"
      >
        There are several ways that you can connect with other members. You can
        change these preferences at any time.
      </p>
      <app-progress-steps
        fxLayout="row"
        fxLayoutGap="8px"
        fxLayoutAlign="center center"
        class="u-display-block"
        [currentStep]="1"
        [numberOfSteps]="numberOfSteps"
      >
      </app-progress-steps>
    </div>
    <form
      [ngStyle]="{ maxWidth: '480px' }"
      class="u-margin-center u-marginBottom-32"
      [formGroup]="interactionsForm"
    >
      <div
        *ngFor="let config of interactionsConfig; let last = last"
        class="u-marginBottom-16 u-paddingBottom-16"
        [ngClass]="{ 'u-borderBottom-grey100': !last }"
      >
        <button
          class="c-button"
          type="button"
          fxLayout="row"
          fxLayoutGap="16px"
          (click)="
            patchForm(
              interactionsForm,
              config.fieldName,
              !interactionsForm.value[config.fieldName]
            )
          "
        >
          <span>
            <ng-container *ngIf="!config.disabled">
              <span *ngIf="!interactionsForm.value[config.fieldName]">
                <mat-icon class="md-24 color-grey-300"
                  >check_box_outline_blank</mat-icon
                >
              </span>
              <span
                *ngIf="interactionsForm.value[config.fieldName]"
                [@fadeInEnter]
              >
                <mat-icon class="md-24 color-teal-700"
                  >check_box_outline</mat-icon
                >
              </span>
            </ng-container>
            <ng-container *ngIf="config.disabled">
              <mat-icon
                class="md-24 color-grey-300 u-opacity-50"
                [nz-tooltip]="config.tooltipText"
                >check_box_outline</mat-icon
              >
            </ng-container>
          </span>
          <div [ngStyle]="{ paddingTop: '4px' }">
            <div
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="8px"
              class="u-marginBottom-8"
            >
              <mat-icon
                class="md-18 u-opacity-80"
                fontSet="material-icons-outlined"
                [ngClass]="{
                  'color-teal-700': interactionsForm.value[config.fieldName],
                  'color-grey': !interactionsForm.value[config.fieldName],
                }"
                >{{ config.iconClass }}</mat-icon
              >
              <p [ngStyle]="{ marginBottom: '4px' }" class="text-subtitle-2">
                <ng-container
                  i18n="
                    @@userOnboardingView.hubPreferences.interactions.configTitle"
                  >{config.title, select, other {{{ config.title }}}
                }</ng-container>
              </p>
            </div>
            <p class="color-grey-300">
              {{ config.description }}
            </p>
          </div>
        </button>
        <div
          *ngIf="'devPrograms' === config.id && programMemberships?.length"
          class="u-marginTop-16 u-paddingLeft-40"
        >
          <ng-container formArrayName="invitedDevPros">
            <ng-container
              *ngFor="
                let membership of getInvitedDevProsFormArray().controls;
                let membershipControlIndex = index
              "
              [formGroupName]="membershipControlIndex"
            >
              <app-user-onboarding-program-form
                formControlName="inviteStatus"
                class="u-display-block u-marginBottom-16"
                [group]="group"
                [programMembership]="programMemberships[membershipControlIndex]"
                [user]="user"
              ></app-user-onboarding-program-form>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </form>
    <div
      [ngStyle]="{ maxWidth: '360px' }"
      class="u-margin-center u-textAlign-center"
    >
      <button
        i18n="@@global.continue"
        type="button"
        mat-raised-button
        color="primary"
        [disabled]="isLoading"
        [appButtonShakeTrigger]="formSubmissionError$"
        (click)="
          updateItems({
            inviteable: interactionsForm.value.inviteable,
            opted_into_matchmaking:
              interactionsForm.value.opted_into_matchmaking,
            searchable: interactionsForm.value.searchable,
          })
        "
      >
        Continue
      </button>
    </div>
  </div>
</div>
<ng-template
  #multiselectCheck
  let-formValue="formValue"
  let-optionName="optionName"
>
  <mat-icon
    [ngStyle]="{ 'vertical-align': 'text-bottom' }"
    class="color-blue md-16"
  >
    @if (formValue.includes(optionName)) {
      check_box_outline
    } @else {
      check_box_outline_blank
    }
  </mat-icon>
</ng-template>
<ng-template #emptyTemplate></ng-template>
